export const REQUIRED_FIELD_ERROR_MESSAGE = 'Required';
